import { render, staticRenderFns } from "./settings-menu.vue?vue&type=template&id=7b1eb176"
import script from "./settings-menu.vue?vue&type=script&lang=js"
export * from "./settings-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports